import React,{useState, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import './end-order.css'; 
import { useSearchParams } from "react-router-dom";
import { Clock, ChevronDown, ChevronUp, RefreshCw } from "feather-icons-react/build/IconComponents";
import { base_api_url } from "../../../environment.jsx";
import axios from "axios";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { getPaymentStatus } from "../../../services/stripeService";

const EndOrder = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  // Récupérer r et t depuis URL ou localStorage
  const restau = searchParams.get("r") || localStorage.getItem('restaurant_id');
  const table = searchParams.get("t") || localStorage.getItem('table_id');
  
  const MySwal = withReactContent(Swal);
  const [loading, setLoading] = useState(true);
  const [showAddToMenuModal, setShowAddToMenuModal] = useState(false); 
  const [getCommande, setGetCommande] = useState([]);
  const [expandedOrder, setExpandedOrder] = useState(null);
  const [refreshing, setRefreshing] = useState(false);
  const [devise, setDevise] = useState(JSON.parse(localStorage.getItem("restaurant"))?.Restaurant?.devise ?? JSON.parse(localStorage.getItem("restaurant"))?.restaurant?.devise)
  const [reference, setReference] = useState(null);

  // 🎭 MODE DÉMO : Mettre à false quand le backend sera prêt
  const DEMO_MODE = true;

  // Nettoyer selectedMenu au montage du composant
  useEffect(() => {
    sessionStorage.removeItem('selectedMenu');
    console.log('🗑️ selectedMenu supprimé du sessionStorage');
  }, []);

  // Vérifier si c'est un retour de paiement Stripe
  useEffect(() => {
    const sessionId = searchParams.get("session_id");
    if (sessionId) {
      if (DEMO_MODE) {
        verifyStripePaymentDemo(sessionId);
      } else {
        verifyStripePaymentProduction(sessionId);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  // 🎭 MODE DÉMO : Vérification simulée
  const verifyStripePaymentDemo = async (sessionId) => {
    try {
      // Récupérer les infos de paiement simulé depuis sessionStorage
      const demoPayment = JSON.parse(sessionStorage.getItem('demo_payment'));
      
      if (demoPayment && demoPayment.sessionId === sessionId) {
        const client = JSON.parse(sessionStorage.getItem("client"));
        
        console.log("🎭 Mode Démo - Paiement simulé confirmé:", {
          sessionId,
          reference: demoPayment.reference,
          amount: demoPayment.amount,
          currency: demoPayment.currency,
          card: demoPayment.card
        });

        // Mettre à jour la commande avec le statut payé
        try {
          await axios.put(`${base_api_url}api/commandes/${client.reference}`, {
            moyen_paiement: 'card',
            notes: `Paiement carte ${demoPayment.card?.brand || 'Carte'} ****${demoPayment.card?.last4 || 'XXXX'} (Mode Démo)`,
            statut: 10,
            statut_paiement: 3 // 3 = Paiement confirmé (Stripe)
          });

          // Message de confirmation avec détails de la carte
          const cardInfo = demoPayment.card ? `
            <div style="background: #f8f9fa; padding: 15px; border-radius: 8px; margin: 15px 0;">
              <p style="margin: 5px 0; color: #666;">
                <strong>${demoPayment.card.brand}</strong> •••• ${demoPayment.card.last4}
              </p>
              <p style="margin: 5px 0; color: #999; font-size: 14px;">
                ${demoPayment.card.name} • Exp: ${demoPayment.card.expiry}
              </p>
            </div>
          ` : '';

          MySwal.fire({
            icon: "success",
            // title: "💳 Paiement Confirmé !",
            html: `
              <div style="text-align: center;">
                ${cardInfo}
                <div style="background: #e7f3ff; padding: 12px; border-radius: 8px; margin: 15px 0;">
                  <p style="margin: 5px 0;"><strong>Montant:</strong> ${demoPayment.amount} ${demoPayment.currency.toUpperCase()}</p>
                  <p style="margin: 5px 0;"><strong>Référence:</strong> ${demoPayment.reference.replace('-2025', '')}</p>
                </div>
                
              </div>
            `,
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 6000,
            timerProgressBar: true,
            customClass: {
              popup: "pixel-toast",
            },
          });

          // Nettoyer les données de démo
          sessionStorage.removeItem('demo_payment');
          sessionStorage.removeItem('selectedMenu');
        } catch (updateError) {
          console.error("Erreur mise à jour commande:", updateError);
          // On continue quand même pour ne pas bloquer la démo
        }
      } else {
        console.warn("Session de paiement simulé non trouvée");
      }
    } catch (error) {
      console.error("Erreur vérification paiement démo:", error);
    }
  };

  // 🔴 PRODUCTION : Vérification réelle avec backend
  const verifyStripePaymentProduction = async (sessionId) => {
    try {
      // Appeler directement l'API Stripe via le service frontend
      const paymentData = await getPaymentStatus(sessionId);
      
      if (paymentData.payment_status === 'paid') {
        const client = JSON.parse(sessionStorage.getItem("client"));
        
        // Mettre à jour la commande avec le statut payé
        await axios.put(`${base_api_url}api/commandes/${client.reference}`, {
          moyen_paiement: 'card',
          statut: 10,
          statut_paiement: 3, // 3 = Paiement confirmé (Stripe)
          stripe_session_id: sessionId,
          notes: `Paiement carte (Stripe Session: ${sessionId})`
        });

        sessionStorage.removeItem('selectedMenu');

        // Récupérer les détails du paiement
        const cardInfo = paymentData.payment_method_details ? `
          <div style="background: #f8f9fa; padding: 15px; border-radius: 8px; margin: 15px 0;">
            <p style="margin: 5px 0; color: #666;">
              <strong>${paymentData.payment_method_details.card?.brand || 'Carte'}</strong> •••• ${paymentData.payment_method_details.card?.last4 || 'XXXX'}
            </p>
          </div>
        ` : '';

        MySwal.fire({
          icon: "success",
          // title: "💳 Paiement Confirmé !",
          html: `
            <div style="text-align: center;">
              ${cardInfo}
              <div style="background: #e7f3ff; padding: 12px; border-radius: 8px; margin: 15px 0;">
                <p style="margin: 5px 0;"><strong>Montant:</strong> ${(paymentData.amount_total / 100).toFixed(2)} ${paymentData.currency.toUpperCase()}</p>
                <p style="margin: 5px 0;"><strong>Session:</strong> ${sessionId.slice(0, 20)}...</p>
              </div>
            </div>
          `,
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 6000,
          timerProgressBar: true,
          customClass: {
            popup: "pixel-toast",
          },
        });
      } else {
        // Paiement non finalisé
        MySwal.fire({
          icon: "warning",
          // title: "Paiement en attente",
          text: `Statut du paiement : ${paymentData.payment_status}`,
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
                    customClass: { popup: "pixel-toast" }
});
      }
    } catch (error) {
      console.error("Erreur vérification paiement Stripe:", error);
      MySwal.fire({
        icon: "error",
        // title: "Erreur de vérification",
        text: "Impossible de vérifier le statut du paiement.",
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
                    customClass: { popup: "pixel-toast" }
});
    }
  };

  // Gérer la navigation du bouton retour
  useEffect(() => {
    // Ajouter une entrée fictive dans l'historique pour intercepter le retour
    window.history.pushState(null, null, window.location.href);

    // Fonction pour gérer le retour
    const handlePopState = (event) => {
      // Empêcher le retour par défaut
      event.preventDefault();
      
      // Ajouter une nouvelle entrée pour éviter une boucle infinie
      window.history.pushState(null, null, window.location.href);
      
      // Afficher une confirmation avant de rediriger
      MySwal.fire({
        icon: "question",
        // title: "Quitter la page ?",
        text: "Vous allez retourner à la liste des menus. Êtes-vous sûr ?",
        showCancelButton: true,
        confirmButtonColor: "#FF6A3D",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "Oui, retourner aux menus",
        cancelButtonText: "Rester ici"
      }).then((result) => {
        if (result.isConfirmed) {
          // Nettoyer la session et rediriger
          sessionStorage.removeItem("client");
          navigate(`/homemenu?r=${restau}&t=${table}`);
        } else {
          // Ajouter de nouveau une entrée fictive si l'utilisateur choisit de rester
          window.history.pushState(null, null, window.location.href);
        }
      });
    };

    // Ajouter l'écouteur d'événement
    window.addEventListener('popstate', handlePopState);

    // Nettoyer l'écouteur lors du démontage du composant
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [restau, table, navigate, MySwal]);

  // Etats pour la gestion des commandes
    useEffect(() => {
      fetchCommands();
    }, []);

  const fetchCommands = async () => {
    setLoading(true);
    const client = JSON.parse(sessionStorage.getItem("client"));
    try {
      const response = await axios.get(`${base_api_url}api/commande/${client.reference}`);
      console.log("Réponse API commandes :", response);
      const commandsData = response.data || [];
      setDevise(JSON.parse(localStorage.getItem("restaurant"))?.restaurant?.devise ?? JSON.parse(localStorage.getItem("restaurant"))?.restaurant?.devise);

        setGetCommande(commandsData);
        setReference(response.data.reference);
        console.log("Commandes récupérées :", commandsData);
        
      } catch (error) {
        console.error("Error fetching commands:", error);
          
          MySwal.fire({
            icon: "error",
            // title: "Aucune commande",
            text: "Aucune commande trouvée pour ce restaurant.",
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            customClass: {
              popup: "pixel-toast",
            },
          });
        
      } finally {
      setLoading(false);
      }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "en_attente": return "#ffc107";
      case "en_preparation": return "#007bff";
      case "prete": return "#28a745";
      case "pret": return "#28a745";
      default: return "#6c757d";
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case "en_attente": return "En attente";
      case "en_preparation": return "En préparation";
      case "prete": return "Prête";
      case "pret": return "Prêt";
      default: return status;
    }
  };

  const getStatusLabel = (statut, statutPaiement) => {
    if (statut == 10) return 'À valider';
    if (statut == 2 || statut == 3) return 'En préparation';
    if (statut == 4 && (statutPaiement == 1 || statutPaiement == 2)) return 'À servir';
    if (statut == 5 && statutPaiement == 1) return 'À encaisser';
    if (statut == 5 && statutPaiement == 2) return 'Terminée';
    if (statut == 0) return 'Annulée';
    return 'Inconnu';
  };

  // Fonction pour rafraîchir le statut de la commande
  const handleRefreshCommand = async () => {
    setRefreshing(true);
    try {
      const client = JSON.parse(sessionStorage.getItem("client"));
      const response = await axios.get(`${base_api_url}api/commande/${client.reference}`);
      const commandsData = response.data || [];
      
      setGetCommande(commandsData);
      
      MySwal.fire({
        icon: "success",
        // title: "Statut actualisé",
        text: "Le statut de votre commande a été mis à jour.",
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        customClass: {
          popup: "pixel-toast",
        },
      });
    } catch (error) {
      console.error("Error refreshing command:", error);
      MySwal.fire({
        icon: "error",
        // title: "Erreur",
        text: "Impossible de mettre à jour le statut de la commande.",
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        customClass: {
          popup: "pixel-toast",
        },
      });
    } finally {
      setRefreshing(false);
    }
  };

   console.log("commande", getCommande);
   const isExpanded = expandedOrder === getCommande.id_commande;

  return (
    <>
      {/* Confetti effect using CSS */}
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        pointerEvents: 'none',
        zIndex: 1,
        background: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Ccircle cx='20' cy='20' r='2' fill='%23FF6A3D' opacity='0.6'/%3E%3Ccircle cx='80' cy='30' r='1.5' fill='%23FF6A3D' opacity='0.4'/%3E%3Ccircle cx='60' cy='10' r='1' fill='%23FF6A3D' opacity='0.5'/%3E%3Ccircle cx='40' cy='70' r='2' fill='%23FF6A3D' opacity='0.3'/%3E%3Ccircle cx='90' cy='80' r='1.5' fill='%23FF6A3D' opacity='0.4'/%3E%3Ccircle cx='10' cy='60' r='1' fill='%23FF6A3D' opacity='0.6'/%3E%3Ccircle cx='70' cy='90' r='2' fill='%23FF6A3D' opacity='0.3'/%3E%3Ccircle cx='30' cy='40' r='1' fill='%23FF6A3D' opacity='0.5'/%3E%3C/svg%3E") repeat`
      }} />
      
      {/* Main container */}
      <div style={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        minHeight: '100vh',
        backgroundColor: '#fff',
        padding: '0 20px',
        textAlign: 'center',
        overflow: 'hidden'
      }}>
        {/* Animated container */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            maxWidth: '400px',
            width: '100%',
            height: '100vh',
            justifyContent: 'space-between',
            paddingTop: 'clamp(60px, 12vh, 95px)',
            paddingBottom: 'clamp(40px, 8vh, 60px)'
          }}
        >
          {/* Logo */}
          <div style={{ 
            flex: 'none',
            marginBottom: 'clamp(60px, 15vh, 102px)'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px'
            }}>
              <img
                src="/assets/img/qr-nyama-command.png"
                alt="Qr Nyama"
                style={{
                  width: 'clamp(90px, 20vw, 110px)',
                  height: 'auto'
                }}
              />
            </div>
          </div>

          {/* Center content group */}
          <div style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            {/* Check Icon */}
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.6, delay: 0.3, type: "spring", bounce: 0.4 }}
              style={{
                backgroundColor: '#FF6A3D',
                borderRadius: '50%',
                padding: 'clamp(20px, 4vw, 24px)',
                marginBottom: 'clamp(30px, 6vh, 52px)',
                boxShadow: '0 8px 32px rgba(255, 106, 61, 0.3)'
              }}
            >
              <Check 
                size={window.innerWidth < 768 ? 60 : 90} 
                color="white" 
                strokeWidth={3}
              />
            </motion.div>

            {/* Message */}
            <motion.h3
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.6 }}
              style={{
                fontSize: 'clamp(24px, 5vw, 32px)',
                fontWeight: '600',
                color: '#FF6A3D',
                marginBottom: 'clamp(6px, 1vh, 8px)',
                lineHeight: '1.3'
              }}
            >
              Votre commande a été envoyée !
            </motion.h3>
            
            {/* Copyable Reference Box */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.7 }}
              onClick={async () => {
                try {
                  await navigator.clipboard.writeText(reference);
                  MySwal.fire({
                    icon: "success",
                    // title: "Référence copiée !",
                    text: `La référence ${reference.replace('-2025', '')} a été copiée dans le presse-papiers.`,
                    toast: true,
                    position: "bottom-end",
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                    customClass: {
                      popup: "pixel-toast",
                    },
                  });
                } catch (err) {
                  // Fallback pour les navigateurs qui ne supportent pas l'API Clipboard
                  const textArea = document.createElement('textarea');
                  textArea.value = reference;
                  document.body.appendChild(textArea);
                  textArea.select();
                  document.execCommand('copy');
                  document.body.removeChild(textArea);
                  
                  MySwal.fire({
                    icon: "success",
                    // title: "Référence copiée !",
                    text: `La référence ${reference.replace('-2025', '')} a été copiée.`,
                    toast: true,
                    position: "bottom-end",
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                    customClass: {
                      popup: "pixel-toast",
                    },
                  });
                }
              }}
              style={{
                backgroundColor: '#F8F9FA',
                border: '2px dashed #FF6A3D',
                borderRadius: '12px',
                padding: '12px 16px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                marginBottom: 'clamp(16px, 3vh, 20px)',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                minWidth: '200px',
                justifyContent: 'center'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = '#FFF4EF';
                e.currentTarget.style.borderColor = '#FF4500';
                e.currentTarget.style.transform = 'scale(1.02)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = '#F8F9FA';
                e.currentTarget.style.borderColor = '#FF6A3D';
                e.currentTarget.style.transform = 'scale(1)';
              }}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <span style={{
                fontSize: 'clamp(16px, 3.5vw, 18px)',
                fontWeight: '600',
                color: '#FF6A3D',
                fontFamily: 'monospace'
              }}>
                #{reference?.replace('-2025', '')}
              </span>
              <svg 
                width="16" 
                height="16" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="#FF6A3D" 
                strokeWidth="2"
                style={{ flexShrink: 0 }}
              >
                <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                <path d="m5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
              </svg>
            </motion.div>
            
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.8 }}
              style={{
                color: '#888',
                fontSize: 'clamp(16px, 3vw, 18px)',
                marginBottom: 0,
                textAlign: 'center'
              }}
            >
              Elle sera prête dans quelques minutes.
            </motion.p>
          </div>

          {/* Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 1 }}
            style={{
              flex: 'none',
              display: 'flex',
              flexDirection: 'column',
              gap: 'clamp(12px, 2vh, 16px)',
              width: '100%'
            }}
          >
            <button
              onClick={() => setShowAddToMenuModal(true)}
              style={{
                backgroundColor: 'transparent',
                color: '#000',
                fontSize: 'clamp(12px, 2.5vw, 14px)',
                textDecoration: 'underline',
                border: 'none',
                cursor: 'pointer',
                padding: '8px',
                transition: 'color 0.2s ease'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.color = '#000';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.color = '#000';
              }}
            >
             Suivre ma commande
            </button>
            <button
              onClick={() => {
                sessionStorage.removeItem("client");
                localStorage.removeItem('type_table')
                navigate(`/homemenu?r=${restau}&t=${table}`);
              }}
              style={{
                backgroundColor: '#FFF4EF',
                color: '#FF6A3D',
                fontWeight: '500',
                borderRadius: '12px',
                padding: 'clamp(14px, 3vw, 16px) 24px',
                fontSize: 'clamp(14px, 3vw, 16px)',
                textDecoration: 'none',
                border: 'none',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                width: '100%',
                textAlign: 'center'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = '#FFE4D6';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = '#FFF4EF';
              }}
            >
              Commander à nouveau
            </button>
            
          </motion.div>
        </motion.div>
      </div>

      {showAddToMenuModal && (
        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Statut de la commande
                </h5>
                <button 
                  type="button" 
                  className="btn-close" 
                  onClick={() => setShowAddToMenuModal(false)}
                ></button>
              </div>
              {loading ? ( 
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Chargement...</span>
                  </div>
                </div>
              ) : (
                <div className="modal-body custom-modal-body p-2 p-sm-3">
                  {/* En-tête avec statut et bouton refresh optimisé mobile */}
                  <div className="d-flex justify-content-between align-items-start mb-3 flex-wrap">
                    <div className="flex-grow-1">
                      <small className="text-muted d-block">
                        Dernière mise à jour: {new Date().toLocaleTimeString('fr-FR', { 
                          hour: '2-digit', 
                          minute: '2-digit' 
                        })}
                      </small>
                    </div>
                    
                    {/* Bouton refresh optimisé mobile */}
                    <button
                      className="btn btn-outline-primary btn-sm d-flex align-items-center"
                      onClick={handleRefreshCommand}
                      disabled={refreshing}
                      style={{
                        borderRadius: "20px",
                        padding: "5px 5px 5px 13px",
                        fontSize: "13px",
                        fontWeight: "500",
                        border: "1px solid #FF4500",
                        backgroundColor: refreshing ? "#f8f9fa" : "transparent",
                        color: refreshing ? "#6c757d" : "#FF4500",
                        transition: "all 0.3s ease"
                      }}
                    >
                      <RefreshCw 
                        size={14} 
                        className={`me-2 ${refreshing ? 'rotating' : ''}`}
                        style={{
                          animation: refreshing ? 'spin 1s linear infinite' : 'none'
                        }}
                      />
                      <span className="d-none d-sm-inline">
                        {refreshing ? "Actualisation..." : "Actualiser"}
                      </span>
                      <span className="d-sm-none">
                        {refreshing ? "..." : ""}
                      </span>
                    </button>
                  </div>                    
                  {getCommande.length === 0 ? (
                    <div className="alert alert-info">
                      Aucune commande.
                    </div>
                  ) : (
                    <div className="row mx-0">
                      <div className="col-12 mb-3 px-0">
                        <div className="card mb-3 shadow-sm">
                          <div 
                            className="card-header bg-white border-bottom cursor-pointer"
                            onClick={() => setExpandedOrder(isExpanded ? null : getCommande.id_commande)}
                            style={{ cursor: 'pointer' }}
                          >
                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                  <h6 className="mb-1">#{getCommande.reference.replace('-2025', '')}</h6>
                                  <div className="mb-1">
                                    <span className="badge rounded-pill" style={{ 
                                      backgroundColor: getCommande.statut == 4 || (getCommande.statut == 5 && getCommande.statut_paiement == 2) ? "#28a745" : 
                                                       getCommande.statut == 2 || getCommande.statut == 10 || getCommande.statut == 3 ? "#ffc107" : "#6c757d",
                                      color: "#fff",
                                      fontWeight: "bold",
                                      fontSize: '10px'
                                    }}>
                                      {getStatusLabel(getCommande.statut, getCommande.statut_paiement)}
                                    </span>
                                  </div>
                                  <small className="text-muted">{getCommande.numtable} • {getCommande.nom}</small>
                                </div>
                              <div className="text-end">
                                <div className="fw-bold">{getCommande.prix} {devise}</div>
                                <small className="text-muted d-flex align-items-center">
                                  <Clock size={12} className="me-1" />
                                  {new Date(getCommande.date_commande).toLocaleTimeString('fr-FR', { 
                                    hour: '2-digit', 
                                    minute: '2-digit' 
                                  })}
                                </small>
                              </div>
                            </div>                                                                            
                            <div className="mt-2 d-flex justify-content-center align-items-center">
                              {isExpanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                            </div>
                          </div>
                          {isExpanded && (
                            <div className="card-body p-2 p-sm-3">
                              <h6 className="mb-3">Articles de la commande:</h6>
                              {getCommande.notes && (
                                <div style={{ backgroundColor: '#223b6b9c', paddingInline: '5px', marginBottom: '5px', borderRadius: '5px', color: '#fff' }}>
                                  <strong>Note:</strong> {getCommande.notes}
                                </div>
                              )}
                              {getCommande.details.map((article) => (
                                <div key={article.id} className="d-flex justify-content-between align-items-center mb-3 p-2 border rounded">
                                  <div className="flex-grow-1">
                                    <div className="fw-semibold">{article.article[0].nom}</div>
                                    <small className="text-muted">
                                      Quantité: {article?.quantite} • {article?.prix_unitaire} {devise}
                                    </small>
                                  </div>

                                  <div className="d-flex align-items-center gap-2">
                                    <span
                                      className="badge rounded-pill"
                                      style={{ backgroundColor: getStatusColor((getCommande.statut == 4 || getCommande.statut == 5) ? "pret" : (article.statut || article.etat) == 1 || (article.statut || article.etat) == 10 ? "en_attente" : (article.statut || article.etat) == 2 || (article.statut || article.etat) == 3 ? "en_preparation" : "pret"), color: '#fff' }}
                                    >
                                      {getStatusText((getCommande.statut == 4 || getCommande.statut == 5) ? "pret" : (article.statut || article.etat) == 1 || (article.statut || article.etat) == 10 ? "en_attente" : (article.statut || article.etat) == 2 || (article.statut || article.etat) == 3 ? "en_preparation" : "pret")}
                                    </span>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}      
                        </div>   
                      </div>
                    </div>
                  )}
                  <div className="d-flex justify-content-between">
                    <button 
                      type="button" 
                      className="btn btn-secondary btn-cancel"
                      onClick={() => setShowAddToMenuModal(false)}
                    >
                      Fermer
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {showAddToMenuModal && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default EndOrder;
